import { formatDADate, getDATimeline, validDADate } from '../lib/daTimeline';

export default function DATimeline({ app, theme }) {
  const events = getDATimeline(app);
  return <details style={{ margin: '12px 0', color: theme.text, fontSize: 'var(--text-sm)' }} onClick={event => event.stopPropagation()}>
    <summary style={{ cursor: 'pointer', padding: '10px 0', minHeight: 24, fontWeight: 600 }}>Dates and changes</summary>
    {validDADate(app.lodged_date) && [app.created_at, app.status_changed_at].some(value => validDADate(value) && validDADate(value) < validDADate(app.lodged_date)) && <p role="note">Some recorded events predate the listed lodged date. These dates need checking and should not be used alone to judge how new the work is.</p>}
    {!formatDADate(app.lodged_date) && <p>Lodged date unavailable.</p>}
    {events.length > 0 ? <ol style={{ paddingLeft: 20 }}>
      {events.map(event => <li key={event.key} style={{ marginBottom: 12 }}>
        <strong>{event.label}: <time dateTime={event.date}>{formatDADate(event.date)}</time></strong>
        <div style={{ color: theme.textMuted, marginTop: 3 }}>{event.detail}</div>
      </li>)}
    </ol> : <p>No dated events are available yet.</p>}
    <p style={{ color: theme.textMuted, fontSize: 'var(--text-xs)', lineHeight: 1.5 }}>This shows the available milestones and latest recorded status change, not a complete change history. The recorded change date may be when SiteScope detected it.</p>
  </details>;
}
